export enum SalesItemType {
  TUR_CRUISE = 'TurCruise',
  EXTRA_HIZMET = 'ExtraHizmet',
  TUR_KULTUR = 'TurKultur',
  OTEL_YURT_ICI = 'OtelYurtIci',
  OTOBUS = 'Otobus',
  TRANSFER = 'Transfer',
  UCAK_BILETI_IC_HAT = 'UcakBiletiIcHat',
  TUR_YURT_DISI = 'TurYurtDisi',
  OTEL_YURT_DISI = 'OtelYurtDisi',
  UCAK_BILETI_DIS_HAT = 'UcakBiletiDisHat',
  IC_HAT_UCAK_BILETI_KDVHARIC = 'IcHatUcakBiletiKDVHaric',
  DIS_HAT_UCAK_BILETI_KDVHARIC = 'DisHatUcakBiletiKDVHaric',
  IC_HAT_UCAK_BILETI_ISKONTO = 'IcHatUcakBiletiIskonto',
  DIS_HAT_UCAK_BILETI_ISKONTO = 'DisHatUcakBiletiIskonto',
  IC_HAT_UCAK_BILETI_HIZMET_BEDELI = 'IcHatUcakBiletiHizmetBedeli',
  DIS_HAT_UCAK_BILETI_HIZMET_BEDELI = 'DisHatUcakBiletiHizmetBedeli',
  IC_HAT_UCAK_BILETI_ALAN_VERGISI = 'IcHatUcakBiletiAlanVergisi',
  DIS_HAT_UCAK_BILETI_ALAN_VERGISI = 'DisHatUcakBiletiAlanVergisi',
  IC_HAT_UCAK_BILETI_EK_HIZMET_BEDELI = 'IcHatUcakBiletiEkHizmetBedeli',
  DIS_HAT_UCAK_BILETI_EK_HIZMET_BEDELI = 'DisHatUcakBiletiEkHizmetBedeli',
  EGITIM = 'Egitim',
  YURT_ICI_OTEL_ISKONTO = 'YurtIciOtelIskonto',
  YURT_ICI_KULTUR_TURU_ISKONTO = 'YurtIciKulturTuruIskonto',
  YURT_DISI_TUR_ISKONTO = 'YurtDisiTurIskonto',
  CRUISE_ISKONTO = 'CruiseIskonto',
  YURT_DISI_OTEL_OTELI_ISKONTO = 'YurtDisiOtelOteliIskonto',
  YURT_ICI_TRANSFER_ISKONTO = 'YurtIciTransferIskonto',
  OTOBUS_ISKONTO = 'OtobusIskonto',
  EKSTRA_HIZMET_ISKONTO = 'EkstraHizmetIskonto',
  OFFLINE_CRUISE = 'OfflineCruise',
  OFFLINE_YURT_DISI_OTEL = 'OfflineYurtDisiOtel',
  OFFLINE_CRUISE_ISKONTO = 'OfflineCruiseIskonto',
  IC_HAT_UCAK_BILETI_KOMISYON = 'IcHatUcakBiletiKomisyon',
  DIS_HAT_UCAK_BILETI_KOMISYON = 'DisHatUcakBiletiKomisyon',
  YURT_ICI_OTELI_KOMISYON = 'YurtIciOteliKomisyon',
  YURT_ICI_KULTUR_TURU_KOMISYON = 'YurtIciKulturTuruKomisyon',
  YURT_DISI_TUR_KOMISYON = 'YurtDisiTurKomisyon',
  CRUISE_KOMISYON = 'CruiseKomisyon',
  YURT_DISI_OTEL_KOMISYON = 'YurtDisiOtelKomisyon',
  YURT_ICI_TRANSFER_KOMISYON = 'YurtIciTransferKomisyon',
  OTOBUS_KOMISYON = 'OtobusKomisyon',
  EKSTRA_HIZMET_KOMISYON = 'EkstraHizmetKomisyon',
  OFFLINE_CRUISE_KOMISYON = 'OfflineCruiseKomisyon',
  YURT_DISI_TUR_HIZMET_BEDELI_KOMISYON = 'YurtDisiTurHizmetBedeliKomisyon',
  ALAN_VERGISI = 'AlanVergisi',
  KKG = 'KKG',
  SERBEST_MESLEK_STOPAJI = 'SerbestMeslekStopaji',
}
